"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const gatsby_1 = require("gatsby");
const styled_components_1 = __importDefault(require("styled-components"));
const _layouts_1 = require("@layouts");
const atoms_1 = require("@components/atoms");
const Input_1 = require("@components/atoms/Input");
const CtaForm_1 = require("@components/organisms/CtaForm");
const _utils_1 = require("@utils"); // Component
var BeginApplication = function BeginApplication() {
    var _React$useState = react_1.default.useState(false), processing = _React$useState[0], setProcessing = _React$useState[1];
    var _React$useState2 = react_1.default.useState(""), salutation = _React$useState2[0], setSalutation = _React$useState2[1];
    var _React$useState3 = react_1.default.useState(""), firstName = _React$useState3[0], setFirstName = _React$useState3[1];
    var _React$useState4 = react_1.default.useState(""), lastName = _React$useState4[0], setLastName = _React$useState4[1];
    var _React$useState5 = react_1.default.useState(""), dateOfBirth = _React$useState5[0], setDateOfBirth = _React$useState5[1];
    var _React$useState6 = react_1.default.useState(""), email = _React$useState6[0], setEmail = _React$useState6[1];
    var _React$useState7 = react_1.default.useState(""), phone = _React$useState7[0], setPhone = _React$useState7[1];
    var _React$useState8 = react_1.default.useState(""), jobTitle = _React$useState8[0], setJobTitle = _React$useState8[1];
    var _React$useState9 = react_1.default.useState(""), addressOne = _React$useState9[0], setAddressOne = _React$useState9[1];
    var _React$useState10 = react_1.default.useState(""), city = _React$useState10[0], setCity = _React$useState10[1];
    var _React$useState11 = react_1.default.useState(""), state = _React$useState11[0], setState = _React$useState11[1];
    var _React$useState12 = react_1.default.useState(""), zip = _React$useState12[0], setZip = _React$useState12[1];
    var _React$useState13 = react_1.default.useState(""), country = _React$useState13[0], setCountry = _React$useState13[1];
    var _React$useState14 = react_1.default.useState(""), howDidYouHearAboutUs = _React$useState14[0], setHowDidYouHearAboutUs = _React$useState14[1];
    var _React$useState15 = react_1.default.useState(""), specifyOther = _React$useState15[0], setSpecifyOther = _React$useState15[1];
    var _React$useState16 = react_1.default.useState(""), specifyPress = _React$useState16[0], setSpecifyPress = _React$useState16[1];
    var _React$useState17 = react_1.default.useState(""), specifyReferral = _React$useState17[0], setSpecifyReferral = _React$useState17[1];
    var _React$useState18 = react_1.default.useState(""), motivation = _React$useState18[0], setMotivation = _React$useState18[1];
    var _React$useState19 = react_1.default.useState(""), whereNext = _React$useState19[0], setWhereNext = _React$useState19[1];
    var _React$useState20 = react_1.default.useState(true), privacyPolicy = _React$useState20[0], setPrivacyPolicy = _React$useState20[1];
    var toggleUserAcceptedTerms = function toggleUserAcceptedTerms() {
        return setPrivacyPolicy(!privacyPolicy);
    };
    var formEnabled = function formEnabled() {
        var pass = true;
        [firstName, lastName, dateOfBirth, email, phone, addressOne, city, state, zip, country].map(function (val) {
            if (pass)
                pass = val !== "";
        });
        return privacyPolicy && pass;
    };
    var sendForm = function sendForm(e) {
        var _document;
        e.preventDefault();
        setProcessing(true);
        var form = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById("membership-form");
        setTimeout(function () {
            return form.submit();
        }, 5);
    };
    return /*#__PURE__*/ react_1.default.createElement(_layouts_1.Layout, {
        dark: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.PageHeader, {
        title: "Apply to Join",
        subhead: "\n          <p>PRIOR Membership unlocks access to Club Journeys and Nomadic Clubhouses around the world, as well as a calendar of events, talks, dinners and parties at home. Membership also gives you access to personalized trip planning from our travel designers.</p>\n          <p><em>Valued at $2500 per annum.</em></p>\n          <p>Our team will review your application and schedule a time to speak.</p>\n        "
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Padding, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Margin, null, /*#__PURE__*/ react_1.default.createElement(Form, {
        name: "membership-form",
        id: "membership-form",
        action: process.env.GATSBY_PARDOT_MEMBERSHIP_FORM_HANDLER,
        method: "POST",
        onSubmit: function onSubmit(e) {
            return sendForm(e);
        }
    }, /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "salutation",
        value: salutation
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "firstName",
        value: firstName
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "lastName",
        value: lastName
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "dateOfBirth",
        value: dateOfBirth
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "email",
        value: email
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "phone",
        value: phone
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "jobTitle",
        value: jobTitle
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "addressOne",
        value: addressOne
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "city",
        value: city
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "state",
        value: state
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "zip",
        value: zip
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "country",
        value: country
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "howDidYouHearAboutUs",
        value: howDidYouHearAboutUs
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "specifyOther",
        value: specifyOther
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "specifyPress",
        value: specifyPress
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "motivation",
        value: motivation
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "whereNext",
        value: whereNext
    }), /*#__PURE__*/ react_1.default.createElement(CtaForm_1.HiddenTextInput, {
        type: "text",
        id: "pardot_extra_field",
        name: "pardot_extra_field"
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.FormHeader, {
        title: "About You",
        noRule: true,
        noPadding: true,
        invert: true
    }), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "select",
        name: "salutation",
        value: salutation,
        label: "Title",
        onChange: function onChange(_ref) {
            var value = _ref.target.value;
            return setSalutation(value);
        },
        noBorder: true,
        options: ['Mr.', 'Ms.', 'Mrs.', 'Dr.', 'Prof.'],
        emptyFirstOption: true,
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, {
        split: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        name: "firstName",
        value: firstName,
        label: "First Name",
        onChange: function onChange(e) {
            return setFirstName(e.target.value);
        },
        required: true,
        noBorder: true,
        disabled: processing
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        name: "lastName",
        value: lastName,
        label: "Last Name",
        onChange: function onChange(_ref2) {
            var value = _ref2.target.value;
            return setLastName(value);
        },
        required: true,
        noBorder: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        name: "dateOfBirth",
        value: dateOfBirth,
        label: "Date of Birth",
        onChange: function onChange(_ref3) {
            var value = _ref3.target.value;
            return setDateOfBirth(value);
        },
        required: true,
        noBorder: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "email",
        name: "email",
        value: email,
        label: "Email Address",
        onChange: function onChange(_ref4) {
            var value = _ref4.target.value;
            return setEmail(value);
        },
        required: true,
        noBorder: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "tel",
        name: "phone",
        value: phone,
        label: "Phone Number",
        onChange: setPhone,
        required: true,
        noBorder: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        name: "jobTitle",
        value: jobTitle,
        label: "Occupation",
        onChange: function onChange(_ref5) {
            var value = _ref5.target.value;
            return setJobTitle(value);
        },
        noBorder: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(atoms_1.FormHeader, {
        title: "Mailing Address",
        invert: true
    }), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        name: "addressOne",
        value: addressOne,
        label: "Address",
        onChange: function onChange(_ref6) {
            var value = _ref6.target.value;
            return setAddressOne(value);
        },
        noBorder: true,
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        name: "city",
        value: city,
        label: "City",
        onChange: function onChange(_ref7) {
            var value = _ref7.target.value;
            return setCity(value);
        },
        noBorder: true,
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, {
        split: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        name: "state",
        value: state,
        label: "State or Province",
        onChange: function onChange(_ref8) {
            var value = _ref8.target.value;
            return setState(value);
        },
        noBorder: true,
        required: true,
        disabled: processing
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        name: "zip",
        value: zip,
        label: "Postal Code",
        onChange: function onChange(_ref9) {
            var value = _ref9.target.value;
            return setZip(value);
        },
        noBorder: true,
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        name: "country",
        value: country,
        label: "Country",
        onChange: function onChange(_ref10) {
            var value = _ref10.target.value;
            return setCountry(value);
        },
        noBorder: true,
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(atoms_1.FormHeader, {
        title: "Additional Information",
        invert: true
    }), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "select",
        name: "howDidYouHearAboutUs",
        value: howDidYouHearAboutUs,
        label: "How did you hear about us?",
        onChange: function onChange(_ref11) {
            var value = _ref11.target.value;
            return setHowDidYouHearAboutUs(value);
        },
        noBorder: true,
        options: ['website', 'press', 'referral', 'social media', 'other'],
        emptyFirstOption: true,
        required: true,
        disabled: processing
    })), howDidYouHearAboutUs === 'other' && /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        name: "specifyOther",
        value: specifyOther,
        label: "Please specify where you heard about us:",
        onChange: function onChange(_ref12) {
            var value = _ref12.target.value;
            return setSpecifyOther(value);
        },
        noBorder: true,
        disabled: processing
    })), howDidYouHearAboutUs === 'press' && /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        name: "specifyPress",
        value: specifyPress,
        label: "Please specify where you read about us:",
        onChange: function onChange(_ref13) {
            var value = _ref13.target.value;
            return setSpecifyPress(value);
        },
        noBorder: true,
        disabled: processing
    })), howDidYouHearAboutUs === 'referral' && /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        name: "specifyReferral",
        value: specifyReferral,
        label: "Please specify who told you about us:",
        onChange: function onChange(_ref14) {
            var value = _ref14.target.value;
            return setSpecifyReferral(value);
        },
        noBorder: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "textarea",
        name: "motivation",
        value: motivation,
        label: "What is your motivation to join PRIOR?",
        onChange: function onChange(_ref15) {
            var value = _ref15.target.value;
            return setMotivation(value);
        },
        noBorder: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "textarea",
        name: "whereNext",
        value: whereNext,
        label: "Where in the world are you dreaming of traveling to next?",
        onChange: function onChange(_ref16) {
            var value = _ref16.target.value;
            return setWhereNext(value);
        },
        noBorder: true,
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(atoms_1.InputCheckbox, {
        name: "privacyPolicy",
        onChange: toggleUserAcceptedTerms,
        checked: privacyPolicy
    }, "I agree to PRIOR\u2019s ", /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/terms-of-use"
    }, "terms of use"), " and ", /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/privacy-policy",
        target: "_blank"
    }, "privacy policy"), "."), /*#__PURE__*/ react_1.default.createElement(ButtonWrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, Object.assign({
        type: "gold",
        size: "large",
        shadow: true,
        display: "flex",
        disabled: !formEnabled || processing,
        onClick: function onClick() { }
    }, {
        processing: processing
    }), "Submit Application"))))));
}; // Styling
var Form = styled_components_1.default.form.withConfig({
    displayName: "begin-application__Form",
    componentId: "sc-1i7ursz-0"
})(["max-width:380px;margin:0 auto;", "{max-width:480px;}", "{max-width:592px;}", "{max-width:680px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Form
var ButtonWrapper = styled_components_1.default.div.withConfig({
    displayName: "begin-application__ButtonWrapper",
    componentId: "sc-1i7ursz-1"
})(["padding-top:8px;", "{padding-top:16px;}"], _utils_1.mediaQuery('desktop'));
exports.default = BeginApplication;
